import styled from '@emotion/styled'
import React from 'react'

import { CTAButton } from '@f-fertighaus/applications/Next/components/common/CTAButton'
import { HeartFilledIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/HeartFilledIcon'
import { HeartIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/HeartIcon'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { transientOptions } from '@f-fertighaus/applications/Next/utils/transientOptions'
import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'
import { useUserDetails } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/hooks/useUserDetails'

export const FavoriteButtonWithText = () => {
  const {
    state: { vendor_nid },
    favoriteHouse: { isFavorite, addToFavorites, removeFromFavorites }
  } = useHouseDetail()
  const userDetails = useUserDetails()

  return userDetails?.ua_user_state ? (
    <StyledButton
      data-isfavorite={isFavorite}
      data-sel='btn-fav-text'
      variant='text'
      color='secondary'
      $active={isFavorite}
      onClick={() => {
        webtrack({
          category: 'CTA-button',
          action: 'click',
          label: 'favourite-house',
          location: 'image-tiles',
          values: [{ type: 'text', value: '(ICON)' }]
        })
        if (isFavorite) {
          removeFromFavorites()
        } else {
          addToFavorites()
        }
      }}
      startIcon={isFavorite ? <HeartFilledIcon /> : <HeartIcon />}>
      {t(
        isFavorite
          ? 'houseDetailPage.added-to-favourites'
          : 'houseDetailPage.favourite'
      )}
    </StyledButton>
  ) : (
    <StyledButton
      className='js-request-button'
      data-request-type='house-wizard-item-favourite'
      data-funnel-variant='house-wizard-item-favourite'
      data-sel='btn-fav-text'
      variant='text'
      color='secondary'
      {...(vendor_nid && { 'data-vendor-nid': vendor_nid })}
      onClick={() =>
        webtrack({
          category: 'CTA-button',
          action: 'click',
          label: 'favourite-house',
          location: 'image-tiles',
          indicates: ['funnel-entry'],
          values: [{ type: 'text', value: '(ICON)' }]
        })
      }
      startIcon={<HeartIcon />}>
      {t('houseDetailPage.favourite')}
    </StyledButton>
  )
}

const StyledButton = styled(CTAButton, transientOptions)<{ $active?: boolean }>`
  position: absolute;
  right: ${({ theme }) => theme.spacing(3)};
  top: ${({ theme }) => theme.spacing(-1)};
  transform: translateY(-100%);
  font-weight: normal;

  > * {
    pointer-events: none;
  }

  svg {
    width: 15px;
    height: 13px;
    * {
      stroke: ${({ theme, $active }) => !$active && theme.palette.text.primary};
    }
  }
`
